const faBroom = {
  prefix: 'fal',
  iconName: 'broom',
  icon: [
    576,
    512,
    [129529],
    'f51a',
    'M571.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-208 208-45.3-45.3c-4.8-4.8-11.2-7.4-17.9-7.4-12.4 0-23 9-25 21.2l-9.1 54.7-9.8-1.4c-46.3-6.6-93 9-126 42L97 287c-21.1 21.1-33 49.8-33 79.7 0 1.3 .1 2.5 .4 3.7 1.7 7.8 8.6 13.6 16.9 13.6L96 384c-14.4 14.4-44.7 44.8-89.4 89.4-4.2 4.2-6.6 10-6.6 16 0 12.5 10.1 22.6 22.6 22.6l171.9 0c39.4 0 77.2-15.6 105-43.5 33.1-33.1 48.6-79.7 42-126l-1.4-9.8 54.7-9.1c12.2-2 21.2-12.6 21.2-25 0-6.7-2.7-13.2-7.4-17.9l-45.3-45.3 208-208zM274.7 242.7l7.2-43.5 94.9 94.9-43.5 7.2-58.7-58.7zM229 266.2l24.7 3.5 52.6 52.6 3.5 24.7c5.2 36.3-7 72.9-33 98.9-21.8 21.8-51.5 34.1-82.4 34.1l-149.2 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9-4.8-11.5-15.8-19.2-28.2-19.7 2.9-16 10.7-30.8 22.3-42.4l10.5-10.5c25.9-25.9 62.6-38.1 98.9-33z',
  ],
};
export default faBroom;
